import { IAppState } from '../../common/state';
import { TYCoordinates } from '../../types/newbuildingHeader';

export const getMapPolygon = ({ newbuildingInformation }: IAppState): TYCoordinates[] | null => {
  return newbuildingInformation?.polygon || null;
};
